<template>
  <DButton
    rounded
    class="hover:text-primary hover:border-primary! h-7 w-7 border border-gray-600 bg-gray-900 p-1 text-gray-300"
    ><Question />
  </DButton>
</template>

<script setup>
import { DButton } from '@disguise/cloud-ui';
import { Question } from '@disguise/cloud-ui/icons';
</script>
